<template>
  <div>
    <div :class="['b-share', size ? size : '']">
      <span class="">{{label}}</span>
    
      <a class="b-share-item " target="_blank" :href="shareLine" v-if="line">
        <i class="icon icon-bor-line" />
      </a>
      <a class="b-share-item" @click="popupMail = true, errCode=''" v-if="email">
        <i class="icon icon-bor-envelope" />
      </a>
      <div class="divider-v "></div>
      <!-- CRM汎用独自対応 -->
      <!-- <div class="item-action " v-if="copy">
        <button class="c-btn btn-sm btn-white btn-copy"
                v-clipboard:copy="handleCopyContent()"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyError">内容をコピー</button>
      </div> -->

      <PopUpSendMail  :visible="popupMail" @show="showPopup" @sendMail="sendMailToAddress($event)" :errCode="errCode" />
      <!-- <div class="item-action hidden lg:block">
        <a class="text-grey-600" href="#">
          <i class="icon icon-bor-circle-question" />
        </a>
      </div>
      <div class="item-action hidden lg:block">
        <a href="#">
          <i class="icon icon-bor-upload share"></i>
        </a>
      </div> -->
     
      <!-- <div class="item-action" v-if="favorite">
        <a @click="handleFavorite">
          <i class="icon icon-bor-heart-solid" v-if="isFavorite" />
          <i class="icon icon-bor-heart-plus" v-else/>
        </a>
      </div> -->
    </div>
    <!-- <InstructionLogin1 :visible="popupLogin" @ok="popupLogin = false" @cancel="popupLogin = false"/> -->
  </div>
</template>

<script>
import _ from 'lodash'
import menu_utils from '@/mixins/menu_utils'
import func_utils from '@/mixins/func_utils'

export default {
  name: 'MenuShare',
  mixins: [menu_utils, func_utils],
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'シェア'
    },
    url: {
      type: String
    },
    success: {
      type: Function
    },
    error: {
      type: Function
    },
   
    line: {
      type: Boolean,
      default: true
    },
    email: {
      type: Boolean,
      default: true
    },
    copy: {
      type: Boolean,
      default: true
    },
    face: {
      type: Boolean,
      default: true
    },
    // favorite: {
    //   type: Boolean,
    //   default: true
    // },
    size: {
      type: String,
      default: 'normal'
    },
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      menuNo: null,
      isFavorite: false,
      favoriteId: null,
      popupLogin: false,
      popupMail: false,
      errCode: '0'
    }
  },
  created() {
    const { menuNo } = this.$route.params
    this.menuNo = menuNo
  },
  mounted() {
    if (this.$auth.loggedIn && this.favorite) {
      this.getFavoriteStatus(this.menuNo).then(
        (result) => {
          this.favoriteId = _.get(result, 'id', '')
          this.isFavorite = _.get(result, 'favourite', false)
        },
        () => {
          
        })
    }
  },
  watch: {
    
  },
  computed: {
    shareFacebook() {
      if (this.url) {
        return `https://www.facebook.com/sharer/sharer.php?u=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`
    },
    shareTwitter() {
      if (this.url) {
        return `https://twitter.com/intent/tweet?text=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://twitter.com/intent/tweet?text=${url}`
    },
    shareLine() {
      if (this.url) {
        return `https://social-plugins.line.me/lineit/share?url=${this.url}`
      }
      const url = encodeURIComponent(location.href)
      return `https://social-plugins.line.me/lineit/share?url=${url}`
    },
    shareEmail() {
      if (this.url) {
        return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${this.url}+&ui=2&tf=1&pli=1'`
      }
      // eslint-disable-next-line quotes
      return `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&body=+${location.href}+&ui=2&tf=1&pli=1'`
    }
  },
  methods: {
    handleCopyContent() {
      const { menuNo, planId, roomId, category, rooms, roomCnt, numPeople, stayNights, adultHeadCnt, checkInDate} = this.$route.query
      const { menuName, planName } = this.info
      const label = [menuName, planName].filter(Boolean).join('\n')
      const url =  `${location.origin}/menus/${menuNo}/plans/${planId}/rooms/${roomId}?category=${category}&rooms=${rooms}&roomCnt=${roomCnt}&numPeople=${numPeople}&stayNights=${stayNights}&adultHeadCnt=${adultHeadCnt}&checkInDate=${checkInDate}`
      const copyData = [label, url].filter(Boolean).join('\n')
      return copyData
    },
    sendMailToAddress($event) {
      const menuNo = this.$route.params
      if(!$event) {
        this.errCode = '1'
      } else {
        let myEmail = null
        myEmail = $event.trim()
        if(this.validEmail(myEmail.trim())) {
          const data = {
            menuNo,          
            email: $event
          }
          this.$repositories('plan').sendMailToAddress(data).then(
            () => {
              this.popupMail = false
            },
            (error) => {
              this.popupMail = false
              this.$toasted.error(error?.message)
            }
          )
        } else {
          this.errCode = '2'
        }
      }
    },
    showPopup($event) {
      this.popupMail = $event
    },
    copySuccess() {
      this.$toasted.success('コピーしました')
    },
    copyError() {
      this.$toasted.error('コピーできません')
    },
    triggerSuccess(type, data) {
      this.$emit('success', {
        type,
        data
      })
    },
    triggerError(type, data) {
      this.$emit('error', {
        type,
        data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>